import { render, staticRenderFns } from "./FFSandbox.vue?vue&type=template&id=580d3fb6&"
import script from "./FFSandbox.vue?vue&type=script&lang=js&"
export * from "./FFSandbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports